// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/support.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/support.proto.
 */
export const file_cortado_v1_support: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * SupportThread represents a support conversation thread
 *
 * @generated from message cortado.v1.SupportThread
 */
export type SupportThread = Message<"cortado.v1.SupportThread"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string subject = 4;
   */
  subject: string;

  /**
   * @generated from field: cortado.v1.SupportThreadStatus status = 5;
   */
  status: SupportThreadStatus;

  /**
   * @generated from field: bool has_unread = 6;
   */
  hasUnread: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 62;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp archived_at = 63;
   */
  archivedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.SupportThread.
 * Use `create(SupportThreadSchema)` to create a new message.
 */
export const SupportThreadSchema: GenMessage<SupportThread> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 0);

/**
 * SupportMessage represents a single message in a support thread
 *
 * @generated from message cortado.v1.SupportMessage
 */
export type SupportMessage = Message<"cortado.v1.SupportMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string thread_id = 2;
   */
  threadId: string;

  /**
   * @generated from field: cortado.v1.SupportMessageSenderType sender_type = 3;
   */
  senderType: SupportMessageSenderType;

  /**
   * @generated from field: string sender_name = 4;
   */
  senderName: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * Page the sender was on when they sent this message. Empty for staff
   * replies (which arrive from Slack) and for messages sent before this was
   * captured.
   *
   * @generated from field: string page_url = 20;
   */
  pageUrl: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.SupportMessage.
 * Use `create(SupportMessageSchema)` to create a new message.
 */
export const SupportMessageSchema: GenMessage<SupportMessage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 1);

/**
 * SupportClientContext records where in the app a user was, and which
 * observability session they were in, at the moment they sent a support
 * message. Support staff use it to open the exact page the user was looking at
 * and to pull up the matching Sentry trace and session replay.
 *
 * @generated from message cortado.v1.SupportClientContext
 */
export type SupportClientContext = Message<"cortado.v1.SupportClientContext"> & {
  /**
   * @generated from field: string page_url = 20;
   */
  pageUrl: string;

  /**
   * @generated from field: string user_agent = 21;
   */
  userAgent: string;

  /**
   * @generated from field: string sentry_trace_id = 30;
   */
  sentryTraceId: string;

  /**
   * @generated from field: string sentry_replay_id = 31;
   */
  sentryReplayId: string;
};

/**
 * Describes the message cortado.v1.SupportClientContext.
 * Use `create(SupportClientContextSchema)` to create a new message.
 */
export const SupportClientContextSchema: GenMessage<SupportClientContext> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 2);

/**
 * SupportScreenshot is one captured screenshot together with the page it was
 * captured on. The URL is per-screenshot because the support panel stays open
 * while the user navigates, so two screenshots in one thread can come from two
 * different pages.
 *
 * @generated from message cortado.v1.SupportScreenshot
 */
export type SupportScreenshot = Message<"cortado.v1.SupportScreenshot"> & {
  /**
   * @generated from field: bytes image = 1;
   */
  image: Uint8Array;

  /**
   * @generated from field: string page_url = 20;
   */
  pageUrl: string;
};

/**
 * Describes the message cortado.v1.SupportScreenshot.
 * Use `create(SupportScreenshotSchema)` to create a new message.
 */
export const SupportScreenshotSchema: GenMessage<SupportScreenshot> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 3);

/**
 * ListSupportThreadsRequest retrieves threads for an organization
 *
 * @generated from message cortado.v1.ListSupportThreadsRequest
 */
export type ListSupportThreadsRequest = Message<"cortado.v1.ListSupportThreadsRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: optional cortado.v1.SupportThreadStatus status = 2;
   */
  status?: SupportThreadStatus;

  /**
   * @generated from field: bool include_archived = 3;
   */
  includeArchived: boolean;
};

/**
 * Describes the message cortado.v1.ListSupportThreadsRequest.
 * Use `create(ListSupportThreadsRequestSchema)` to create a new message.
 */
export const ListSupportThreadsRequestSchema: GenMessage<ListSupportThreadsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 4);

/**
 * ListSupportThreadsResponse contains the list of support threads
 *
 * @generated from message cortado.v1.ListSupportThreadsResponse
 */
export type ListSupportThreadsResponse = Message<"cortado.v1.ListSupportThreadsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.SupportThread threads = 1;
   */
  threads: SupportThread[];
};

/**
 * Describes the message cortado.v1.ListSupportThreadsResponse.
 * Use `create(ListSupportThreadsResponseSchema)` to create a new message.
 */
export const ListSupportThreadsResponseSchema: GenMessage<ListSupportThreadsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 5);

/**
 * GetSupportThreadRequest retrieves a specific thread
 *
 * @generated from message cortado.v1.GetSupportThreadRequest
 */
export type GetSupportThreadRequest = Message<"cortado.v1.GetSupportThreadRequest"> & {
  /**
   * @generated from field: string thread_id = 1;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.GetSupportThreadRequest.
 * Use `create(GetSupportThreadRequestSchema)` to create a new message.
 */
export const GetSupportThreadRequestSchema: GenMessage<GetSupportThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 6);

/**
 * GetSupportThreadResponse contains the thread and its messages
 *
 * @generated from message cortado.v1.GetSupportThreadResponse
 */
export type GetSupportThreadResponse = Message<"cortado.v1.GetSupportThreadResponse"> & {
  /**
   * @generated from field: cortado.v1.SupportThread thread = 1;
   */
  thread?: SupportThread;

  /**
   * @generated from field: repeated cortado.v1.SupportMessage messages = 2;
   */
  messages: SupportMessage[];
};

/**
 * Describes the message cortado.v1.GetSupportThreadResponse.
 * Use `create(GetSupportThreadResponseSchema)` to create a new message.
 */
export const GetSupportThreadResponseSchema: GenMessage<GetSupportThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 7);

/**
 * CreateSupportThreadRequest creates a new support thread
 *
 * @generated from message cortado.v1.CreateSupportThreadRequest
 */
export type CreateSupportThreadRequest = Message<"cortado.v1.CreateSupportThreadRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * Deprecated: raw screenshot bytes with no capture context. Superseded by
   * screenshot_captures; still accepted so clients deployed before that field
   * existed keep working.
   *
   * @generated from field: repeated bytes screenshots = 3 [deprecated = true];
   * @deprecated
   */
  screenshots: Uint8Array[];

  /**
   * @generated from field: repeated cortado.v1.SupportScreenshot screenshot_captures = 4;
   */
  screenshotCaptures: SupportScreenshot[];

  /**
   * @generated from field: cortado.v1.SupportClientContext client_context = 20;
   */
  clientContext?: SupportClientContext;
};

/**
 * Describes the message cortado.v1.CreateSupportThreadRequest.
 * Use `create(CreateSupportThreadRequestSchema)` to create a new message.
 */
export const CreateSupportThreadRequestSchema: GenMessage<CreateSupportThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 8);

/**
 * CreateSupportThreadResponse contains the created thread
 *
 * @generated from message cortado.v1.CreateSupportThreadResponse
 */
export type CreateSupportThreadResponse = Message<"cortado.v1.CreateSupportThreadResponse"> & {
  /**
   * @generated from field: cortado.v1.SupportThread thread = 1;
   */
  thread?: SupportThread;
};

/**
 * Describes the message cortado.v1.CreateSupportThreadResponse.
 * Use `create(CreateSupportThreadResponseSchema)` to create a new message.
 */
export const CreateSupportThreadResponseSchema: GenMessage<CreateSupportThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 9);

/**
 * SendSupportMessageRequest sends a message to a thread
 *
 * @generated from message cortado.v1.SendSupportMessageRequest
 */
export type SendSupportMessageRequest = Message<"cortado.v1.SendSupportMessageRequest"> & {
  /**
   * @generated from field: string thread_id = 1;
   */
  threadId: string;

  /**
   * @generated from field: string body = 2;
   */
  body: string;

  /**
   * @generated from field: cortado.v1.SupportClientContext client_context = 20;
   */
  clientContext?: SupportClientContext;
};

/**
 * Describes the message cortado.v1.SendSupportMessageRequest.
 * Use `create(SendSupportMessageRequestSchema)` to create a new message.
 */
export const SendSupportMessageRequestSchema: GenMessage<SendSupportMessageRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 10);

/**
 * SendSupportMessageResponse contains the created message
 *
 * @generated from message cortado.v1.SendSupportMessageResponse
 */
export type SendSupportMessageResponse = Message<"cortado.v1.SendSupportMessageResponse"> & {
  /**
   * @generated from field: cortado.v1.SupportMessage message = 1;
   */
  message?: SupportMessage;
};

/**
 * Describes the message cortado.v1.SendSupportMessageResponse.
 * Use `create(SendSupportMessageResponseSchema)` to create a new message.
 */
export const SendSupportMessageResponseSchema: GenMessage<SendSupportMessageResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 11);

/**
 * ArchiveSupportThreadRequest archives a support thread
 *
 * @generated from message cortado.v1.ArchiveSupportThreadRequest
 */
export type ArchiveSupportThreadRequest = Message<"cortado.v1.ArchiveSupportThreadRequest"> & {
  /**
   * @generated from field: string thread_id = 1;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.ArchiveSupportThreadRequest.
 * Use `create(ArchiveSupportThreadRequestSchema)` to create a new message.
 */
export const ArchiveSupportThreadRequestSchema: GenMessage<ArchiveSupportThreadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 12);

/**
 * ArchiveSupportThreadResponse is the response for archiving a support thread
 *
 * @generated from message cortado.v1.ArchiveSupportThreadResponse
 */
export type ArchiveSupportThreadResponse = Message<"cortado.v1.ArchiveSupportThreadResponse"> & {
};

/**
 * Describes the message cortado.v1.ArchiveSupportThreadResponse.
 * Use `create(ArchiveSupportThreadResponseSchema)` to create a new message.
 */
export const ArchiveSupportThreadResponseSchema: GenMessage<ArchiveSupportThreadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 13);

/**
 * MarkSupportThreadReadRequest marks a thread as read by the current user
 *
 * @generated from message cortado.v1.MarkSupportThreadReadRequest
 */
export type MarkSupportThreadReadRequest = Message<"cortado.v1.MarkSupportThreadReadRequest"> & {
  /**
   * @generated from field: string thread_id = 1;
   */
  threadId: string;
};

/**
 * Describes the message cortado.v1.MarkSupportThreadReadRequest.
 * Use `create(MarkSupportThreadReadRequestSchema)` to create a new message.
 */
export const MarkSupportThreadReadRequestSchema: GenMessage<MarkSupportThreadReadRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 14);

/**
 * MarkSupportThreadReadResponse is the response for marking a thread as read
 *
 * @generated from message cortado.v1.MarkSupportThreadReadResponse
 */
export type MarkSupportThreadReadResponse = Message<"cortado.v1.MarkSupportThreadReadResponse"> & {
};

/**
 * Describes the message cortado.v1.MarkSupportThreadReadResponse.
 * Use `create(MarkSupportThreadReadResponseSchema)` to create a new message.
 */
export const MarkSupportThreadReadResponseSchema: GenMessage<MarkSupportThreadReadResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 15);

/**
 * GetUnreadSupportThreadCountRequest gets the count of threads with unread staff messages
 *
 * @generated from message cortado.v1.GetUnreadSupportThreadCountRequest
 */
export type GetUnreadSupportThreadCountRequest = Message<"cortado.v1.GetUnreadSupportThreadCountRequest"> & {
  /**
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message cortado.v1.GetUnreadSupportThreadCountRequest.
 * Use `create(GetUnreadSupportThreadCountRequestSchema)` to create a new message.
 */
export const GetUnreadSupportThreadCountRequestSchema: GenMessage<GetUnreadSupportThreadCountRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 16);

/**
 * GetUnreadSupportThreadCountResponse contains the unread thread count
 *
 * @generated from message cortado.v1.GetUnreadSupportThreadCountResponse
 */
export type GetUnreadSupportThreadCountResponse = Message<"cortado.v1.GetUnreadSupportThreadCountResponse"> & {
  /**
   * @generated from field: int32 count = 1;
   */
  count: number;
};

/**
 * Describes the message cortado.v1.GetUnreadSupportThreadCountResponse.
 * Use `create(GetUnreadSupportThreadCountResponseSchema)` to create a new message.
 */
export const GetUnreadSupportThreadCountResponseSchema: GenMessage<GetUnreadSupportThreadCountResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_support, 17);

/**
 * SupportThreadStatus represents the status of a support thread
 *
 * @generated from enum cortado.v1.SupportThreadStatus
 */
export enum SupportThreadStatus {
  /**
   * @generated from enum value: SUPPORT_THREAD_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_THREAD_STATUS_NEW = 1;
   */
  NEW = 1,

  /**
   * @generated from enum value: SUPPORT_THREAD_STATUS_IN_PROGRESS = 2;
   */
  IN_PROGRESS = 2,

  /**
   * @generated from enum value: SUPPORT_THREAD_STATUS_RESOLVED = 3;
   */
  RESOLVED = 3,
}

/**
 * Describes the enum cortado.v1.SupportThreadStatus.
 */
export const SupportThreadStatusSchema: GenEnum<SupportThreadStatus> = /*@__PURE__*/
  enumDesc(file_cortado_v1_support, 0);

/**
 * SupportMessageSenderType represents who sent a support message
 *
 * @generated from enum cortado.v1.SupportMessageSenderType
 */
export enum SupportMessageSenderType {
  /**
   * @generated from enum value: SUPPORT_MESSAGE_SENDER_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_SENDER_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: SUPPORT_MESSAGE_SENDER_TYPE_STAFF = 2;
   */
  STAFF = 2,
}

/**
 * Describes the enum cortado.v1.SupportMessageSenderType.
 */
export const SupportMessageSenderTypeSchema: GenEnum<SupportMessageSenderType> = /*@__PURE__*/
  enumDesc(file_cortado_v1_support, 1);

/**
 * SupportService provides support chat functionality
 *
 * @generated from service cortado.v1.SupportService
 */
export const SupportService: GenService<{
  /**
   * ListSupportThreads retrieves support threads for an organization
   *
   * @generated from rpc cortado.v1.SupportService.ListSupportThreads
   */
  listSupportThreads: {
    methodKind: "unary";
    input: typeof ListSupportThreadsRequestSchema;
    output: typeof ListSupportThreadsResponseSchema;
  },
  /**
   * GetSupportThread retrieves a specific support thread with its messages
   *
   * @generated from rpc cortado.v1.SupportService.GetSupportThread
   */
  getSupportThread: {
    methodKind: "unary";
    input: typeof GetSupportThreadRequestSchema;
    output: typeof GetSupportThreadResponseSchema;
  },
  /**
   * CreateSupportThread creates a new support thread with an initial message
   *
   * @generated from rpc cortado.v1.SupportService.CreateSupportThread
   */
  createSupportThread: {
    methodKind: "unary";
    input: typeof CreateSupportThreadRequestSchema;
    output: typeof CreateSupportThreadResponseSchema;
  },
  /**
   * SendSupportMessage sends a message to an existing support thread
   *
   * @generated from rpc cortado.v1.SupportService.SendSupportMessage
   */
  sendSupportMessage: {
    methodKind: "unary";
    input: typeof SendSupportMessageRequestSchema;
    output: typeof SendSupportMessageResponseSchema;
  },
  /**
   * ArchiveSupportThread archives a support thread
   *
   * @generated from rpc cortado.v1.SupportService.ArchiveSupportThread
   */
  archiveSupportThread: {
    methodKind: "unary";
    input: typeof ArchiveSupportThreadRequestSchema;
    output: typeof ArchiveSupportThreadResponseSchema;
  },
  /**
   * MarkSupportThreadRead marks a support thread as read by the current user
   *
   * @generated from rpc cortado.v1.SupportService.MarkSupportThreadRead
   */
  markSupportThreadRead: {
    methodKind: "unary";
    input: typeof MarkSupportThreadReadRequestSchema;
    output: typeof MarkSupportThreadReadResponseSchema;
  },
  /**
   * GetUnreadSupportThreadCount returns the count of threads with unread staff messages
   *
   * @generated from rpc cortado.v1.SupportService.GetUnreadSupportThreadCount
   */
  getUnreadSupportThreadCount: {
    methodKind: "unary";
    input: typeof GetUnreadSupportThreadCountRequestSchema;
    output: typeof GetUnreadSupportThreadCountResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_cortado_v1_support, 0);

